import { FilteringModule } from './../shared/filtering-module';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DbmanagerService} from '../services/dbmanager.service';
import { Item, FieldType } from '../models/Item';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FilterDialogComponent, FilterItem } from '../shared/filter-dialog/filter-dialog.component';

@Component({
  selector: 'app-itemslist',
  templateUrl: './itemslist.component.html',
  styleUrls: ['./itemslist.component.css']
})
export class ItemslistComponent implements OnInit, OnDestroy {

  items: Array<Item>;
  filters: Array<FilterItem>;
  constructor(private dbservice: DbmanagerService, private router: Router, private dialog: MatDialog) {
  }

  itemsSubscription ;
  fieldType = FieldType ;
  sortDirectionUp = true;

  ngOnInit(): void {
    this.filters = Array<FilterItem>();
    this.items = Array.from(this.dbservice.items.values());
    this.itemsSubscription = this.dbservice.getItems().subscribe(items => {
      this.items = Array.from(items.values());
      this.updateItemsStatus();
      this.sortDirectionUp = false;
      this.sortList(FieldType.LastEntry);
    });
    this.updateItemsStatus();
    this.sortDirectionUp = false;
    this.sortList(FieldType.LastEntry);
  }

  ngOnDestroy() {
    this.itemsSubscription.unsubscribe();
  }

  updateItemsStatus() {
    for (const item of this.items) {
      const location = this.dbservice.locations.get(item.LOCATION);
      if (location !== undefined) {
        if ((location.INVENTORY_STATUS === 'FINISHED') ||
            (location.INVENTORY_STATUS === 'INPROGRESS') ||
            (location.INVENTORY_STATUS === 'STARTED')) {
          if (item.EDIT_DATETIME > location.INVENTORY_DATE) {
            item.STATUS = 'finished';
          } else {
            item.STATUS = 'inprogress';
          }
        } else if (location.INVENTORY_STATUS === 'CANCELED') {
          if (item.EDIT_DATETIME > location.INVENTORY_DATE) {
            item.STATUS = 'finished';
          } else {
            item.STATUS = 'cancel';
          }
        }
      } else {
        item.STATUS = 'unknow';
      }
    }
  }

  clicktest(tagid) {
    this.router.navigate(['/itemdetails'], {
      queryParams: {
        UID: tagid
      }
    });
  }

  getNameColumnData(item): string {
    if ((item.TITLE !== undefined) && (item.TITLE.length > 0)) {
      return item.TITLE;
    } else if (item.DESCRIPTION !== undefined) {
      return item.DESCRIPTION;
    }
    return '';
  }

  getUserName(userId): string {
    return this.dbservice.users.get(userId).NAME;
  }

  getType(): string {
    return this.dbservice.type;
  }

  getLocaleDate(Date): string {
    return new DatePipe('PL').transform(Date.toDate(), 'medium');
  }

  getUserSurname(userId): string {
    return this.dbservice.users.get(userId).SURNAME;
  }

  gestStatus(ID): string {
    return 'status';
  }

  sortList(column: FieldType) {
    switch (column) {
      case FieldType.Description:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.DESCRIPTION > i2.DESCRIPTION) :
                                                            (i1.DESCRIPTION < i2.DESCRIPTION)) ? 1 : -1);
        break;

      case FieldType.Category:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.CATEGORY > i2.CATEGORY) :
                                                            (i1.CATEGORY < i2.CATEGORY)) ? 1 : -1);
        break;

      case FieldType.Mark:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.MARK > i2.MARK) :
                                                            (i1.MARK < i2.MARK)) ? 1 : -1);
        break;

      case FieldType.Status:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.STATUS > i2.STATUS) :
                                                            (i1.STATUS < i2.STATUS)) ? 1 : -1);
        break;

      case FieldType.LastEntry:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.EDIT_DATETIME >= i2.EDIT_DATETIME) :
                                                            (i1.EDIT_DATETIME <= i2.EDIT_DATETIME)) ? 1 : -1);
        break;

      case FieldType.Location:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.LOCATION > i2.LOCATION) :
                                                            (i1.LOCATION < i2.LOCATION)) ? 1 : -1);
        break;

      case FieldType.State:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.STATE > i2.STATE) :
                                                            (i1.STATE < i2.STATE)) ? 1 : -1);
        break;

      case FieldType.Remarks:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.REMARKS > i2.REMARKS) :
                                                            (i1.REMARKS < i2.REMARKS)) ? 1 : -1);
        break;

      case FieldType.UserName:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.USERNAME > i2.USERNAME) :
                                                            (i1.USERNAME < i2.USERNAME)) ? 1 : -1);
        break;

      case FieldType.UserSurname:
        this.items.sort((i1, i2) => (this.sortDirectionUp ? (i1.USERSURNAME > i2.USERSURNAME) :
                                                            (i1.USERSURNAME < i2.USERSURNAME)) ? 1 : -1);
        break;
    }
    this.sortDirectionUp = !this.sortDirectionUp;
  }

  openFilters() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      filters: this.filters,
    };
    const dataDialogRef = this.dialog.open(FilterDialogComponent, dialogConfig).afterClosed().subscribe(data => {
        const filter = new FilteringModule();
        this.filters = data;
        if ((data.length === 1) && (data[0].args[0].length === 0)) {
          return ;
        }
        this.items = Array.from(this.dbservice.items.values());
        (data as Array<FilterItem>).forEach(row => {
          this.items = filter.sort(row.filter, row.type, row.args, this.items);
        });
      }
    );
  }
}
